// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"bd6a5297","149":"f0f7b27a","189":"d0836220","202":"aea61c10","424":"308baa24","490":"f0cfc6f1","518":"4e835b63","667":"87f5e046","781":"64853e4e"}[chunkId] + ".chunk.js";
};